@if (appointment$ | async; as appointment) {
  <mat-toolbar color="accent">Take Deposit</mat-toolbar>

  <mat-dialog-content class="!text-black">
    <div class="flex flex-col gap-8">
      <div class="flex flex-col gap-4">
        <header
          class="flex gap-6 rounded-md border border-slate-200 bg-slate-50 p-3 text-sm text-slate-700"
        >
          <div class="flex flex-1 basis-0 flex-col gap-1">
            <div class="flex items-center gap-2">
              <mat-icon class="icon-xs" matTooltip="Patient">person</mat-icon>
              <span>{{ patientName }}</span>
            </div>

            <div class="flex items-center gap-2">
              <mat-icon class="icon-xs" matTooltip="Practitioner"
                >badge</mat-icon
              >
              <span>{{ appointment.practitioner.name }}</span>
            </div>

            <div class="flex items-center gap-2">
              <mat-icon class="icon-xs" matTooltip="Treatment">title</mat-icon>
              <span>{{ appointment.treatmentPlan.treatmentStep.name }}</span>
            </div>
          </div>

          @if (eventDisplay$ | async; as eventDisplay) {
            <div class="flex flex-1 basis-0 flex-col gap-1">
              <div class="flex items-center gap-2">
                <mat-icon class="icon-xs" matTooltip="Date"
                  >calendar_today</mat-icon
                >
                <span>{{ eventDisplay.date }}</span>
              </div>

              <div class="flex items-center gap-2">
                <mat-icon class="icon-xs" matTooltip="Time">schedule</mat-icon>
                <span>{{ eventDisplay.time }}</span>
              </div>
            </div>
          }
        </header>

        @if (depositAmount$ | async; as depositAmount) {
          <div
            class="flex items-center justify-between gap-4 rounded-md border border-amber-200 bg-amber-50 p-3 text-amber-900"
          >
            <div class="flex flex-col gap-0.5">
              <span class="text-sm font-medium">Deposit required</span>
              <span class="text-xs">
                This deposit is required to secure the appointment.
              </span>
            </div>
            <span class="text-xl font-semibold">{{ depositAmount }}</span>
          </div>
        }
      </div>

      <pr-take-deposit-panel
        [appointment]="appointment"
        [entry]="entry"
        (sendPaymentLink)="sendPaymentLink(appointment, $event)"
        (captured)="depositCaptured()"
        (skipped)="depositSkipped()"
      />
    </div>
  </mat-dialog-content>
}
